import apiFetch from '../apiFetch'

export default function (token, templateId) {
  return apiFetch({ endPoint: `template/${templateId}/clone`, method: 'POST', token: token })
}
